export const mockOrder = {
  items: [
    {
      name: "French Fries",
      quantity: 2,
      modifiers: [
        {
          name: "Ketchup",
          quantity: 3,
          price: 0.5,
        },
        {
          name: "Mayonnaise",
          quantity: 1,
          price: -0.50,
        }
      ],
      price: 18.90,
    },
    {
      name: "French Fries",
      quantity: 1,
      modifiers: [],
      price: 18.90,
    },
    {
      name: "French Fries",
      quantity: 2,
      modifiers: [
        {
          name: "Ketchup",
        },
        {
          name: "Mayonnaise",
          quantity: 1,
          price: 0.50,
        }
      ],
      price: 18.90,
    },
  ],
  modifiers: [{
    name: "5$ coupon",
    price: -5,
    quantity: 1
  }],
  taxPrice: 2.24,
  subTotal: 18.90 * 3,
  finalPrice: 18.90 * 3,
}
